<template>
    <div>
        <h2 class="mb-1">{{ $t("settings.users.basic-info") }}</h2>

        <validation-provider #default="{ errors }" name="name" rules="required">
            <b-form-group
                id="fieldset-name"
                :description="$t('settings.users.name.description')"
                :label="$t('settings.users.name.label')"
                content-cols-lg="7"
                content-cols-sm
                label-cols-lg="3"
                label-cols-sm="4"
                label-for="name"
            >
                <b-form-input
                    id="name"
                    v-model="userData.name"
                    :disabled="userData && userData.id && !userData.auth0Id"
                    :state="!errors || errors.length < 1 ? null : false"
                    name="name"
                />
                <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
        </validation-provider>

        <b-form-group
            id="fieldset-displayName"
            :description="$t('settings.users.display-name.description')"
            :label="$t('settings.users.display-name.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
            label-for="displayName"
        >
            <b-form-input
                id="displayName"
                v-model="userData.displayName"
                :disabled="userData && userData.id && !userData.auth0Id"
                name="displayName"
            />
        </b-form-group>

        <validation-provider #default="{ errors }" name="email" rules="required|email">
            <b-form-group
                id="fieldset-email"
                :description="$t('settings.users.email.description')"
                :label="$t('settings.users.email.label')"
                content-cols-lg="7"
                content-cols-sm
                label-cols-lg="3"
                label-cols-sm="4"
                label-for="email"
            >
                <b-form-input
                    id="email"
                    v-model="userData.email"
                    :disabled="userData && userData.id && !userData.auth0Id"
                    name="email"
                />
                <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
        </validation-provider>

        <b-form-group
            id="fieldset-role"
            :description="$t('settings.users.role.description')"
            :label="$t('settings.users.role.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
            label-for="role"
        >
            <b-form-radio-group
                v-if="hasAbilityToUpdateRole"
                v-model="userData.role"
                :disabled="userData && userData.id && !userData.auth0Id"
                :options="options"
                button-variant="light"
                buttons
                inline
                name="role"
            />
            <b-form-input v-else :value="$t(`roles.${userData.role}`)" disabled name="role" />
        </b-form-group>

        <b-form-group
            id="fieldset-enforce-team-filter"
            :description="$t('settings.users.enforce-team-filter.description')"
            :label="$t('settings.users.enforce-team-filter.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
            label-for="enforceTeamFilter"
        >
            <b-form-checkbox
                v-model="formUserSettings.enforceTeamFilter.value"
                :unchecked-value="0"
                :value="1"
                inline
                name="enforceTeamFilter"
                switch
            />
        </b-form-group>
        <b-form-group
            v-if="formUserSettings.enforceTeamFilter.value == 1"
            id="fieldset-enforce-unassigned-chats"
            :description="$t('settings.users.enforce-unassigned-chats.description')"
            :label="$t('settings.users.enforce-unassigned-chats.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
            label-for="enforceUnassignedChats"
        >
            <b-form-checkbox
                v-model="formUserSettings.enforceUnassignedChats.value"
                :unchecked-value="0"
                :value="1"
                inline
                name="enforceUnassignedChats"
                switch
            />
        </b-form-group>
        <hr />
    </div>
</template>
<script>
import { BFormGroup, BFormInput, BFormRadioGroup, BButton, BFormCheckbox } from "bootstrap-vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { getInstance } from "@/auth/auth0";
import i18n from "@/libs/i18n/";
import useUsersForm from "@/views/modules/settings/users/useUsersForm";
import { required, email } from "@validations";

export default {
    components: {
        BFormGroup,
        BFormInput,
        BFormRadioGroup,
        BButton,
        BFormCheckbox,
        ValidationProvider,
        ValidationObserver,
        required,
    },
    props: {
        userData: {
            type: Object,
            required: true,
        },
    },
    setup() {
        const { formUserSettings } = useUsersForm();
        const hasAbilityToUpdateRole = Boolean(
            getInstance().$ability.j?.find((ability) => ability.subject === "userRole")
        );
        const options = [
            {
                text: i18n.t("roles.user"),
                value: "user",
            },
            {
                text: i18n.t("roles.manager"),
                value: "manager",
            },
            {
                text: i18n.t("roles.admin"),
                value: "admin",
            },
        ];

        return {
            hasAbilityToUpdateRole,
            options,
            formUserSettings,
        };
    },
};
</script>
